import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { LabelSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { StyledRouterLink } from '../ui/StyledRouterLink';

type Props = Readonly<{
  historic: {
    label: string;
    path?: string;
  }[];
  actions?: React.ReactNode;
  withDivider?: boolean;
}>;

function CustomBreadcrumbs({ actions, withDivider = true, historic }: Props) {
  const { classes, concatenateClasses, theme, css } = useStyles();

  return (
    <>
      <FlexRow
        classNames={concatenateClasses(
          classes.centeredBetween,
          css({
            padding: `${theme.sizing.scale100} ${theme.sizing.scale600}`,
            minHeight: '44px',
            boxSizing: 'border-box',
          }),
        )}
      >
        <FlexRow
          gap={theme.sizing.scale500}
          classNames={css({
            boxSizing: 'border-box',
            alignItems: 'center',
          })}
        >
          {historic.map((item, index) => {
            const isLastItem = historic.length - 1 === index;
            return isLastItem ? (
              <LabelSmall>{item.label}</LabelSmall>
            ) : (
              <>
                {item.path && (
                  <StyledRouterLink to={item.path}>
                    <LabelSmall>{item.label}</LabelSmall>
                  </StyledRouterLink>
                )}
                {!item.path && <LabelSmall>{item.label}</LabelSmall>}
                <MaterialIcon
                  name={'navigate_next'}
                  size="mini"
                />
              </>
            );
          })}
        </FlexRow>
        {actions}
      </FlexRow>
      {withDivider && (
        <StyledDivider
          style={{ width: '100%', margin: 0 }}
          $size="cell"
        />
      )}
    </>
  );
}

export default CustomBreadcrumbs;
